<ng-container *ngIf="resume$ | async as resume">
  <ng-container *ngIf="resume.length >= 1">
    <div class="resume-container card shadow-sm">
      <app-resume-product-card
        *ngFor="let product of resume"
        [product]="product"
      ></app-resume-product-card>
      <div class="card-footer">
        <div>
          Quantity: <strong>{{ quantity$ | async }}</strong>
        </div>
        <div>
          Total: <strong>{{ total$ | async | currency }}</strong>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
